// Module
var code = "<p class=ibanMatch> <span class=ibanMatchFirst ng-bind-html=match.label.matchQueryMarkup></span> <span class=ibanMatchSeparator> &gt; </span><span class=ibanMatchSecond ng-bind=match.label[match.label.oppositeType]></span> </p> ";
// Exports
var _module_exports = code;;
var path = 'app/components/inbox/categorizeIncomingDocument/ibanAssign/templates/item.tpl.html';
window.angular.module('app').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;